import Page from 'src/apipages/reference/index';

export default Page;
